<!-- 代理相关 -->
<template>
	<c-dialog ref="dialog" title="代理库" width="900" @resolve="resolve">
		<m-search ref="search" @search="search">
			<c-form ref="form" inline>
				<!-- <c-form-item type="input" label="会员名" name="login_name"></c-form-item> -->
				<c-form-item type="input" label="代理手机号" name="user_manage_mobilephone"></c-form-item>
				<c-form-item type="input" label="代理昵称" name="nick_name"></c-form-item>
<!--				<c-form-item type="checkbox" label="实名认证" name="authentication_state" :options="authenticationStateType"></c-form-item>-->
			</c-form>
		</m-search>
			
		<c-table ref="table" height="400">
			<c-table-column
				type="selector"
				:multiple="!!multiple"
			></c-table-column>
			
			<!-- <c-table-column
				label="会员名"
				name="login_name"
			></c-table-column> -->
			
			<c-table-column
				label="代理昵称"
				name="nick_name"
			>
				<template v-slot="{data}">
					<div class="flex-center-cross">
						<c-image :src="data.head_photo" preview size="30" style="margin-right: 10px;"></c-image>
						<span>{{data.nick_name}}</span>
					</div>
				</template>
			</c-table-column>
			
			<c-table-column
				label="代理手机号"
				name="user_manage_mobilephone"
                width="120"
            ></c-table-column>
			
			<c-table-column
				label="等级"
				name="user_level_name"
			></c-table-column>
			
<!--			<c-table-column
			        label="实名认证"
			        name="state"
			        width="80"
			>
			    <template v-slot="{data}">
					<span v-if="data.authentication_state==1" style="color:darkgreen">已认证</span>
					<span v-else style="color:#666666">未认证</span>
			    </template>
			</c-table-column>-->
			
			<c-table-column
			        label="姓名"
			        name="name"
			        width="80"
			>
			    <template v-slot="{data}">
					<span v-if="data.name&&data.authentication_state==1">{{data.name}}</span>
					<span v-else style="color:#666666">--</span>
			    </template>
			</c-table-column>
		</c-table>
	</c-dialog>
</template>

<script>
	export default {
		props: {
			multiple: Boolean
		},

        data() {
            return {
              authenticationStateType:[
                {
                    name:'未实名认证',
                    value:0
                },{
                    name:'已实名认证',
                    value:1
                }
              ]
            }
        },
		
		methods: {
			search(data) {
				this.$refs.table.load({
					url: '/member_user/list',
					data
				});
			},
			
			open() {
				this.$refs.form.clear();
				this.$refs.search.search();
				this.$refs.dialog.open();
			},
			
			resolve(stop) {
				var data = this.$refs.table.getRow('selected');
				if (!data.length) {
					stop();
					this.$message({
						text: '请选择代理'
					});
					return;
				}
				this.$emit('resolve', Array.from(data, item => item.data));
			}
		}
	}
</script>